export class CrossAuthError {
    crossautherr = {
        code: 'auth/wrong-user-section',
        message: 'The user is not registered for this application.'
    };
}
